enum API {
	REPORTS_CLASSROOMS = '/api/reports/classrooms',
	REPORTS_PROGRESS = '/api/reports/progress',
	REPORTS_SCORE_OF_CERTIFICATION = '/api/reports/scoreOfCertifications',
	REPORTS_SCORE_OF_CERTIFICATION_SUBJECTS = '/api/reports/scoreOfCertifications/subjectList',
	REPORTS_MODULE = '/api/reports/modules',
	CERTIFICATION_REPORTS = '/api/reports/attestationReportSheet'
}

export default API;
